{
	"ariaBackToAIStylesList": "Back To AI Styles List",
	"backToStyles": "Back to AI Styles",
	"failedCreateTitle": "Failed to Create AI Style",
	"failedCreateMessage": "Please try again later.",
	"loadingDetails": "Loading style details...",
	"notNow": "Not Now",
	"panelTitle": "AI Styles",
	"styleCreated": "Your AI Style has been created!",
	"styleCreatedMessage": "{{name}} has been successfully created.",
	"styleNotFound": "Style not found",
	"styleNotFoundMessage": "We couldn't find the style you're looking for. It might have been removed or you may no longer have access to it.",
	"unableCreateTitle": "Unable to Create AI Style",
	"unableCreateMessage": "The collection you are trying to create an AI Style from is not published, or you don't have permission",
	"useStyle": "Use Style"
}
